import createVueApp from '@phoenix/createVueApp';
import StoreSearchResults from '@maison/components/store/StoreSearchResults.vue';

const app = createVueApp({}, true);
app.component('StoreSearchResults', StoreSearchResults);
app.mount('#phoenix-store-search-results');
